/**
 * <PdfInline> — un PDF posé dans la page, au web : ses pages à la largeur de la colonne, sans geste ;
 * un appui sur une page l'ouvre en grand (`onOpen`). Chargement et repli : ceux de la visionneuse.
 */
import React, { useState } from "react"
import { View } from "react-native"

import { Card } from "../Card"
import { PdfFallback } from "./PdfFallback.web"
import { PdfPageSkeleton } from "./PdfPageSkeleton"
import { PdfPages } from "./PdfPages.web"
import { usePdfDocument } from "./usePdfDocument.web"

export type PdfInlineProps = {
    uri: string
    /** Un appui sur une page : l'ouvrir en grand. */
    onOpen: () => void
    /** Le PDF ne s'est pas chargé : la cause que rend pdf.js. Absent : rien. */
    onError?: (cause: unknown) => void
    testID?: string
}

export function PdfInline(props: PdfInlineProps) {
    const { uri, onOpen, onError, testID } = props
    const load = usePdfDocument(uri, onError)
    const [width, setWidth] = useState(0)

    return (
        <View onLayout={(event) => setWidth(event.nativeEvent.layout.width)} testID={testID}>
            {load.status === "ready" ? (
                <PdfPages doc={load.doc} pages={load.pages} boxWidth={width} onPressPage={onOpen} />
            ) : load.status === "failed" ? (
                <Card background="surface-subtle" elevation="none" p="6">
                    <PdfFallback uri={uri} />
                </Card>
            ) : (
                <PdfPageSkeleton />
            )}
        </View>
    )
}
